module.exports = __webpack_public_path__ + "img/ieee_mp_section.f953d73d.jpg";